module.exports = __webpack_public_path__ + "static/ofi-logo-f8eb4a84acf9f25f6119a8eae5e72274.png";